import { TabPanel, Toolbar } from "devextreme-react";
import { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import ProjectInformationClinicalTrials from "./ProjectPerformanceHistoryClinicalTrials";
import ProjectPerformanceHistoryOther from "./ProjectPerformanceHistoryOther";

export default function ProjectInformation() {
  return (
    <React.Fragment>
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            PROJECT INFORMATION
          </span>
        </Item>
      </Toolbar>
      <TabPanel id="projectInfoTabPanel" deferRendering={false}>
        <TabPanelItem title={"프로젝트 수행이력 (임상)"}>
          <ProjectInformationClinicalTrials />
        </TabPanelItem>
        <TabPanelItem title={"프로젝트 수행이력 (기타)"}>
          <ProjectPerformanceHistoryOther />
        </TabPanelItem>
      </TabPanel>
    </React.Fragment>
  );
}
